'use strict';

var validator = require('../validator');
var populateErrorMessages = require('../validationMessage');
var formValidation = require('base/components/formValidation');
var orderTrackErrorMessages = {};
var returningCustomerErrorMessages = {};
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('../utils');

module.exports = {
    oninit: function () {
        setTimeout(function () {
            $('.returningCustomerForm #RC-login-form-email').removeAttr('disabled');
        }, 3000);

        // when user moves focus out of password field on Track order page
        $(document).on('focusout', '.order-track-section #RC-login-form-password', function () {
            const passwordInput = $(this);
            setTimeout(() => {
                if (passwordInput.val() === '') {
                    passwordInput.siblings('.invalid-feedback').show();
                }
            }, 100);
        });
    },

    returningCustomerValidationHandler: function () {
        // $('form.login').each(function () {
        var $Form = $('.returningCustomerForm');
        var $Email = $Form.find('#RC-login-form-email');
        var $Password = $Form.find('#RC-login-form-password');
        populateErrorMessages(returningCustomerErrorMessages, $Email);
        populateErrorMessages(returningCustomerErrorMessages, $Password);
        validator.init($Form, {
            ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
            ...validator.ENABLED_BUTTON_SETTINGS,
            messages: returningCustomerErrorMessages
        });
        // });
    },

    orderTrackValidationHandler: function () {
        var $orderTrackForm = $('.orderTrackForm');
        var $orderNumber = $orderTrackForm.find('#order-track-form-orderNumber');
        var $email = $orderTrackForm.find('#order-track-form-email');
        var $shippingZipCode = $orderTrackForm.find('#order-track-form-shippingZipCode');
        populateErrorMessages(orderTrackErrorMessages, $orderNumber);
        populateErrorMessages(orderTrackErrorMessages, $email);
        populateErrorMessages(orderTrackErrorMessages, $shippingZipCode);
        validator.init($orderTrackForm, {
            ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
            ...validator.ENABLED_BUTTON_SETTINGS,
            messages: orderTrackErrorMessages
        });
        utils.formatOrderNumber($orderNumber);
        utils.formatZip($shippingZipCode);
    },

    orderTrackFormSubmit: function () {
        // eslint-disable-next-line
        $('form.orderTrackForm').submit(function (e) {
            e.preventDefault();
            if ($('.alert').is(':visible')) {
                $('.alert').fadeOut('fast');
            }
            var form = $('form.orderTrackForm');
            var defer = $.Deferred(); // eslint-disable-line
            if (!form.valid()) {
                return defer;
            }
            let orderNumberInput = $('#order-track-form-orderNumber');
            const orderNumber = orderNumberInput.val().trim();
            orderNumberInput.val(orderNumber);
            const orderEmail = $('#order-track-form-email').val();
            const orderShippingZipCode = $('#order-track-form-shippingZipCode').val();
            let url = $('.orderTrackForm').attr('action');
            let encryptQuery = btoa(`orderEmail=${orderEmail}&orderShippingZipCode=${orderShippingZipCode}`);
            url = `${url}&orderID=${orderNumber}&orderTrackToken=${encryptQuery}`;
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    const { redirectUrl } = data;
                    window.location.href = redirectUrl;
                },
                error: function (data) {
                    $.spinner().stop();
                    const errorMessage = data.responseJSON.errorMsg;
                    if (errorMessage) {
                        utils.showErrorToast(errorMessage);
                    }
                }
            });
        });
    },

    returningCustomerForm: function () {
        // eslint-disable-next-line
        $('form.returningCustomerForm').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var email = $('input#RC-login-form-email');
            email.val($.trim(email.val()));
            var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn');
            var defer = $.Deferred(); // eslint-disable-line
            if (!form.valid()) {
                tealiumEnable.getAnalyticsData('accountLoginErrorMsg', 'emailPasswordLogin', false, fromModal);
                return defer;
            }
            let url = $(this).attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    $('.header-signin-global-error').empty();
                    if (data.success) {
                        if (data.isMigratedCustomerFirstLogin) {
                            if (data.updatePasswordHtml) {
                                $('body').append(data.updatePasswordHtml);
                                var $requestNewCustomerPasswordResetModal = $('#requestNewCustomerPasswordResetModal');
                                utils.openModal($requestNewCustomerPasswordResetModal);
                                $requestNewCustomerPasswordResetModal.find('#email').val(data.email);
                            }
                            $.spinner().stop();
                        } else {
                            tealiumEnable.getAnalyticsData('creatAccountAndLoginEvent', 'login', false, fromModal, data.email);
                            const { redirectUrl } = data;
                            window.location.href = redirectUrl;
                        }
                    } else {
                        $.spinner().stop();
                        const errorMessage = data.error && data.error.length ? data.error[0] : '';
                        if (errorMessage) {
                            // utils.showErrorToast(errorMessage);
                            formValidation(form, data);
                            $('.order-history-navigation-view').hide();
                            $('.alert-danger').append('<span class="icon-alert"></span>');
                            $('#RC-login-form-email').addClass('error is-invalid');
                            $('#RC-login-form-password').addClass('error is-invalid');
                        }
                        tealiumEnable.getAnalyticsData('creatAccountAndLoginEvent', 'login_failure', false, fromModal, data.email);
                    }
                    if (data.accountLocked) {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data && data.responseJSON && data.responseJSON.action === 'Ajax-Response' && data.responseJSON.success === false) {
                        $('.order-history-navigation-view').hide();
                        $('.header-signin-global-error').empty().append(`<div class="signin-error"><span class="icon-alert"> </span> <div>${$('.akamai-error-msg').attr('data-akamai-error-msg')} <span class="ref-id">${data.responseJSON['ckdr:'] ? data.responseJSON['ckdr:'] : data.responseJSON['thdr:']} </span></div></div>`);
                    }
                    $.spinner().stop();
                }
            });
        });
    }
};
